/**
 * Main AAF playing state
 */
export const AAFPLAYER_PLAY = 'PLAYING';
export const AAFPLAYER_STOP = 'STOPPING';

/**
 * Tipos de contenido que se playean
 * El "grabado", debería ser del tipo VOD?
 */
export const AAF_CONTENT_IS_NPVR = 'content_is_npvr';
export const AAF_CONTENT_IS_VOD = 'content_is_vod';
export const AAF_CONTENT_IS_CATCHUP = 'content_is_catchup';
export const AAF_CONTENT_IS_STARTOVER = 'content_is_startover';
export const AAF_CONTENT_IS_TIMESHIFT = 'content_is_timeshift'; // Este pronto se deprecará
export const AAF_CONTENT_IS_TV = 'content_is_tv';
export const AAF_CONTENT_IS_AUDIO = 'content_is_audio';
export const AAF_CONTENT_IS_RADIO = 'content_is_radio';
export const CONTENT_TYPES_ON_LIVE = [
  AAF_CONTENT_IS_CATCHUP,
  AAF_CONTENT_IS_STARTOVER,
  AAF_CONTENT_IS_TV,
];
export const AAF_FLOW_CALL_CENTER = 'FLOW_CALL_CENTER';
export const AAF_FLOW_ADDON = 'AAF_FLOW_ADDON';
export const AAF_FLOW_PACKAGE = 'AAF_FLOW_PACKAGE';
/**
 * TODO Este debería ser el único lugar donde se definen las constantes de abajo
 * Tipos de streaming
 */
export const SS = 'smooth_streaming';
export const DASHWV = 'dashwv';
export const DASHWV_MA = 'dashwv_ma';
export const SS_MA = 'smooth_streaming_ma';
export const HLS = 'hls';
export const HLS_MA = 'hls_ma';
export const HLS_KR = 'hls_kr';
export const HLSPRM = 'hlsprm';
export const IP_MULTICAST = 'ip_multicast';
export const IP_MULTICAST_UDP = 'ip_multicast_udp';
export const IP_MULTICAST_LMS = 'ip_multicast_lms';
export const DVBC = 'dvbc';
export const DVBS = 'dvbs';
export const WVC = 'widevine_classic';
export const AUDIO = 'audio';
export const RADIO = 'radio';
export const SPOT = 'spot';
export const PLAYERIMAGE = 'image';
export const DASH_CMAF = 'dash_cmaf';

/**
 * Tipos de logging messages
 */
export const LOG_BASIC = 0;
export const LOG_WARNING = 1;
export const LOG_ERROR = 2;
export const LOG_INFO = 3;

/**
 * Time retry playing
 */
export const retryTimeEventsAndroid = 11000; // Se cambia a 11 segs + los 4.5 segs que tarda el interval android = 15.5 segs, osea mas o menos como estaba, en 15 segs.
export const retryTimeEvents = 4000;
export const retryTimeEventsFirstTime = 180000;

/**
 * PGM errors para saber si reintentar llamada pgm hasta encontrar un streamType soportado por el device
 */
export const PLY_PLY_00009 = 'PLY_PLY_00009'; // Content is not available in the requested format
export const PLY_PLY_00001 = 'PLY_PLY_00001'; // Invalid stream type
export const PLY_TIMEOUT = '28'; // Invalid stream type

// Border color general in input outfocus
export const INPUT_STYLE_OUTFOCUS = '3px solid #4C6F94';

//Mundial
export const QATAR2022ENABLED = 'qatar2022_enabled';
export const MUNDIAL2022 = 'mundial2022';
export const KEYQATAR2022DEFAULT = '{"default": {"enable": {"susc": true,"no_susc": true,"anonymous": false},"interval_time": 60}}';

export const APIVERSION = 'v5.94';
export const SUPPORTEDSTREAMTYPE = 'supported_stream_time';
export const DEFAULT = 'default';
export const LIVE = 'live';
export const REGION = 'region';
export const HOMEUSER = 'homeuser';

export const RENT = 'rent';
export const BUY = 'buy'
export const COLORFILTERBUTTON = '#2e303d';
export const REENVIARMENSAJE = 'REENVIAR MENSAJE';
export const ACEPTAR = 'ACEPTAR';
export const TELMEX2FA = 'confirma compra telmex 2FA';
export const MODAL60S = 'modal confirma compra 60 segundos';
export const MODALLIMITECOMPRAS = 'modal limite de compras';
export const ACTUALIZATUSDATOS = 'actualiza tus datos';
export const MODALACTUALIZATUSDATOS = 'modal actualiza tus datos';
export const SIGUIENTE = 'SIGUIENTE';
export const AYUDACONFIRMACION = 'necesitas ayuda con tu confirmación'
export const MODALAYUDACONFIRMACION = 'modal necesitas ayuda con tu confirmación'
export const LIMITEINTENTOSDIARIOS = 'limite de intentos diarios';
export const MODALLIMITEINTENTOSDIARIOS = 'modal limite de intentos diarios';
export const CODIGOEXPIRADO = 'codigo expirado';
export const MODALCODIGOEXPIRADO = 'modal codigo expirado';
export const SOLICITARCODIGOEXPIRADO = 'SOLICITAR CÓDIGO EXPIRADO';
export const ADEUDOLINEATEMEX = 'adeudo en linea telmex';
export const MODALADEUDOLINEATEMEX = 'modal adeudo en linea telmex';
export const DESLEP = ' de| ';
export const DEMODEL = ' de ';
export const BACK = 'BACK';
export const DELETE = 'delete';
export const GET = 'get';
export const SUCCESFULL = 'successful';
export const IPTELMEX = 'TELMEX_REGISTER';
export const LOGIN = 'LOGIN';
export const REGISTER = 'REGISTER'
export const HIDE = 'hide'
export const MODALOVERLAYMAIN = 'modal-overlay-main'
export const MODALLANDINGTELMEX = 'landingtelmex'





// WEBPACK FOOTER //
// ./src/AAFPlayer/constants.js